<template lang="pug">
div
    modal-trocar-responsavel(
      v-if="showModalResponsavel",
      :processo="processoTrocado",
      @closeModal="FECHAR_MODAL_RESPONSAVEL",
      @refresh="refresh"
    )
    modal-trocar-responsavel-lote(
      v-if="showModalResponsavelLote && idsProcessos.length > 0",
      :idsProcessos="idsProcessos",
      caixa="CAIXA_EMISSAO_TITULO",
      @closeModal="FECHAR_MODAL_RESPONSAVEL_LOTE",
      @refresh="refresh"
    )
    app-modal-visualizar-completo(
        v-if="showModalVisualizarProcesso && idProcesso !== null",
        @closeModal="showModalVisualizarProcesso = false",
        :idProcesso="idProcesso",
        :protocolo="protocolo",
        :numeroProcesso="numeroProcesso",
        :tipo="tipoProcesso"
    )
    el-card.card-container(shadow="hover")
        filtro(
            @pesquisar="pesquisar",
            @limpar="clear",
            :showOs="true",
            :showMunicipios="true",
            :configuracaoFiltro="configuracaoFiltro",
            :filtroRapido="filtroRapido"
            :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
        )
    app-listagem(
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunasComTituloDinamico",
    :json-data="items",
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="true",
    :filtro="filtro",
    :hasMultipleCheckbox="showTrocaAnalistaLote()",
    :showButtonVincularResponsavelLote="showTrocaAnalistaLote()",
    @atualizarFiltro="atualizarFiltro",
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false",
    @selectItem="SELECIONA_PROCESSO"
    @selectAll="SELECT_ALL_PROCESSOS"
    @vincularResponsavelLote="ABRIR_MODAL_RESPONSAVEL_LOTE"
    @exportarCsvFiltroAnalise="exportarCsvFiltroAnalise"

    )
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppListagem from '@/components/AppListagem'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
import ModalTrocarResponsavel from '@/screens/analise/components/ModalTrocarResponsavel'
import ModalTrocarResponsavelLote from '@/screens/analise/components/ModalTrocarResponsavelLote'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
const { filtro, showFiltroTipoMultiplo } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto,
    ModalTrocarResponsavel,
    ModalTrocarResponsavelLote
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('CAIXA_EMISSAO_TITULO'),
      idProcesso: null,
      processo: {},
      showModalVisualizarProcesso: false,
      items: [],
      protocolo: '',
      tipoProcesso: '',
      totalElements: 0,
      setorSelecionado: null,
      numeroProcesso: '',
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.CAIXA_EMISSAO_TITULO || [],
        filtroResponsavel: filtro?.filtroResponsavel?.CAIXA_EMISSAO_TITULO || [],
        filtroBairro: filtro?.filtroBairro?.CAIXA_EMISSAO_TITULO || [],
        filtroCpf: filtro?.filtroCpf?.CAIXA_EMISSAO_TITULO || []
      },
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Data Chegada', propriedade: 'dataChegadaSetor', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Tipo de Processo', propriedade: 'tipo', ordem: 5, acoes: [] },
        { id: 5, titulo: 'Situação', propriedade: 'status', ordem: 6, acoes: [] },
        { id: 4, titulo: 'Município', propriedade: 'municipio', sortable: true, ordem: 3, acoes: [], exibir: () => true },
        { id: 8, titulo: 'Área Requerida (ha)', propriedade: 'areaImovel', ordem: 5, acoes: [], exibir: () => this.isEstadoMA },
        { id: 9, titulo: 'Data de vencimento', propriedade: 'dataVencimento', ordem: 7, acoes: [], isPrazo: true, exibir: () => this.isEstadoMA },
        { id: 7, titulo: 'Responsável', propriedade: 'responsavel', ordem: 5, acoes: [], exibir: () => true },
        {
              id: 6, titulo: 'Ações', propriedade: 'tipo', ordem: 7, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Emitir Título', icone: 'fa-file-contract', codigo: 'EMITIR', ordem: 1, show: this.showEmitirTitulo },
            { id: 3, nome: 'Continuar Emissão do Título', icone: 'fa-file-contract', codigo: 'CONTINUAR_EMISSAO', ordem: 1, show: this.showContinuarEmitirTitulo, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 4, nome: 'Vincular Responsável', icone: 'fa-user-plus', codigo: 'TROCAR_ANALISTA', ordem: 1, show: this.showVincularAnalista },
            { id: 5, nome: 'Trocar Responsável', icone: 'fa-user-edit', codigo: 'TROCAR_ANALISTA', ordem: 1, show: this.showTrocarResponsavel },
            { id: 22, nome: 'Conferir Título', icone: 'fa-check', codigo: 'CONFERIR_TITULO', ordem: 1, show: this.showConferirTitulo, showToltip: this.showToltip, textToltip: this.textToltip },
            { id: 16, nome: 'Continuar Conferência do Título', icone: 'fa-check', codigo: 'CONTINUAR_CONFERENCIA_TITULO', ordem: 1, show: this.showContinuarConferenciaTitulo, showToltip: this.showToltip, textToltip: this.textToltip }
          ]
        }
      ],
      showFiltroTipoMultiplo,
      filtroRapido: null,
      processoTrocado: null,
      showModalResponsavel: false,
      showModalResponsavelLote: false,
      idsProcessos: []
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },

  created () {
    if (this.usuario) {
      this.idUsuario = this.usuario.id
      this.setorSelecionado = this.usuario.perfilSelecionado?.setor?.codigo || null
    }
  },

  watch: {
    async '$route' (to, from) {
      this.init()
    }
  },

  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    }),
    colunasComTituloDinamico () {
      return this.colunas.map(coluna => {
        if (coluna.id === 8 && coluna.propriedade === 'areaImovel') {
          const titulo = (this.usuario && this.isAnalistaCTRU()) ? 'Área Requerida (m²)' : 'Área Requerida (ha)'
          return { ...coluna, titulo }
        }
        return coluna
      })
    }
  },

  methods: {
    ...mapActions({
      cancelarBoletoDesarquivamento: 'processo/cancelarBoletoDesarquivamento',
      exportarCsvAnalise: 'processo/exportarCsvAnalise'
    }),
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.setDadosProcesso(item)
      this.showModalVisualizarProcesso = true
    },
    async EMITIR (_this, { item }) {
      await this.executarTramitacao(item.id)
      this.$router.push({
        name: 'continuar-emissao-titulo-ma',
        params: {
          idProcesso: item.id,
          tipo: 'EMITIR_TITULO',
          urlOrigem: 'CAIXA_EMISSAO_TITULO'
        }
      })
    },
    async CONTINUAR_EMISSAO (_this, { item }) {
      if (item.numeroTituloCertidao && item.tipoCodigo === 'CERTIDAO_TITULO') {
        this.$router.push({
          name: 'LISTAGEM_CERTIDAO',
          query: { tipo: 'TITULO_CERTIDAO' },
          params: {
            idProcesso: item.id,
            urlOrigem: 'CAIXA_EMISSAO_TITULO'
          }
        })
      } else {
        this.$router.push({
          name: 'continuar-emissao-titulo-ma',
          params: {
            idProcesso: item.id,
            tipo: 'EMITIR_TITULO',
            urlOrigem: 'CAIXA_EMISSAO_TITULO'
          }
        })
      }
    },
    TROCAR_ANALISTA: (_this, { item }) => {
      _this.processoTrocado = item
      _this.showModalResponsavel = true
    },
    async CONFERIR_TITULO (_this, { item }) {
      if (this.isEstadoMA) {
        await _this.executarTramitacao(item.id)
      }
      this.$router.push({
        name: 'conferencia-titulo-certidao-ma',
        params: {
          idProcesso: item.id,
          tipo: 'EMITIR_TITULO',
          numeroProcesso: item.numeroProcesso
        }
      })
    },
    async CONTINUAR_CONFERENCIA_TITULO (_this, { item }) {
      this.$router.push({
        name: 'conferencia-titulo-certidao-ma',
        params: {
          idProcesso: item.id,
          tipo: 'EMITIR_TITULO',
          numeroProcesso: item.numeroProcesso
        }
      })
    },
    FECHAR_MODAL_RESPONSAVEL () {
      this.showModalResponsavel = false
    },
    SELECIONA_PROCESSO (item) {
      item.selecionado = !item.selecionado
      if (item.selecionado) {
        this.idsProcessos.push(item.id)
      } else {
        this.idsProcessos.splice(this.idsProcessos.indexOf(item.id), 1)
      }
    },
    SELECT_ALL_PROCESSOS (itens) {
      this.idsProcessos = itens.map(item => item.id)
    },
    ABRIR_MODAL_RESPONSAVEL_LOTE () {
      if (this.idsProcessos.length <= 0) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          'Você deve selecionar ao menos um processo.')
        return
      }
      this.showModalResponsavelLote = true
    },
    FECHAR_MODAL_RESPONSAVEL_LOTE () {
      this.showModalResponsavelLote = false
    },
    setDadosProcesso (item) {
      this.idProcesso = item.id
      this.numeroProcesso = item.numeroProcesso
      this.processo = item
      this.protocolo = item.numeroProtocolo
      this.tipoProcesso = item.tipoCodigo
      this.processo = item
    },
    atualizarFiltro (novoFiltro) {
      this.filtroRapido = novoFiltro
    },
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    },
    exportarCsvFiltroAnalise () {
      this.exportarCsvAnalise(this.filtro)
    }
  }
}
</script>
<style lang="scss" scoped>
    .card-container {
      margin: 20px;
      border-radius: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaEmissaoTitulo.vue